import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Box, Typography } from "@mui/material";

const data = [
  {
    name: "The Dark Knight",
    days: 5,
  },
  {
    name: "Mission Impossible",
    days: 2,
  },
  {
    name: "Minority Report",
    days: 3,
  },
  {
    name: "Iron Man",
    days: 7,
  },
];

const ContentApprovalTimeGraph = () => {
  return (
    <Box
      sx={{
        border: "1px solid lightgrey",
        padding: "20px",
        borderRadius: "10px",
      }}
      textAlign={"center"}
      width={"100%"}
    >
      <Typography textAlign={"center"} variant="p" width={"100%"} gutterBottom>
        Content Approval Time
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            style={{ fontSize: "12px" }}
            interval={0} // Ensures all labels are shown
            angle={0} // Rotate labels to prevent overlap
            dy={10} // Adjust label position
          />
          <YAxis tickFormatter={(tick) => `${tick}`} />
          <Tooltip formatter={(value) => `${value}`} />
          <Legend />
          <Bar dataKey="days" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default ContentApprovalTimeGraph;
